module.exports = "uniform sampler2D tDiffuse;\nin vec2 vUv;\nvoid main() {\n    outFragColor = texture(tDiffuse, vUv);\n}\n";